import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import TermsOfService from './TermsOfService';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;
